import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.primary,
  paddingBottom: theme.spacing(14),
  '& .TLVBGContainer': {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    zIndex: 0,
    height: '100vh',
    '&:after': {
      content: '""',
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      height: '80%',
      zIndex: 1,
      background: `linear-gradient(to top, ${theme.palette.background.primary} 0%, transparent 100%)`,
    },
  },
  '& .TLVContantContainer': {
    position: 'relative',
    zIndex: 2,
    '& .TLVCustomContainer': {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),

      [theme.breakpoints.up('lg')]: {
        paddingLeft: theme.spacing(8),
        paddingRight: theme.spacing(8),
      },
    },
  },
  '& .TLVFilterContainer': {
    position: 'sticky',
    top: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: theme.zIndex.appBar + 1,
    [theme.breakpoints.down('lg')]: {
      margin: 0,
    },
  },
  '& .TLResetBtn': {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    padding: 0,
    fontSize: 'inherit',
    fontWeight: 500,
  },
   '& .TLVDescription': {
    color: theme.palette.text.secondary,
    maxWidth: theme.spacing(119.652),
    textAlign: 'center',
    marginTop: theme.spacing(8),
   
  },
}));

export default StyledBox;
